/**
 * Created by KryQ on 2017-04-26.
 */

import React from "react";
import { Col, Button } from "reactstrap";
import cx from "classnames";
import update from "immutability-helper";
var axios = require("axios");

export default class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
      loading: true,
      settings: {
        speed_limit: 50,
        speed_display_limit: 120,
        lower_measurement_threshold: 10,
        upper_measurement_threshold: 110,
        range: 10,
        direction: 1,
        flash: false,
        display: true,
        power_save: true,
        text: "",
      },
    };

    this.closePanel = this.closePanel.bind(this);
    this.loadSettings = this.loadSettings.bind(this);
    this.saveSettings = this.saveSettings.bind(this);
  }

  loadSettings(id) {
    this.setState({
      loading: true,
    });

    axios
      .get(this.props.restIp + "/traps/" + id)
      .then(
        function (response) {
          this.setState({
            loading: false,
            settings: {
              speed_limit: response.data.speed_limit,
              speed_display_limit: response.data.speed_display_limit,
              lower_measurement_threshold:
                response.data.lower_measurement_threshold,
              upper_measurement_threshold:
                response.data.upper_measurement_threshold,
              range: response.data.range,
              direction: response.data.direction,
              flash: response.data.flash,
              display: response.data.display,
              power_save: response.data.power_save,
              text: response.data.text,
            },
          });
        }.bind(this)
      )
      .catch(function (error) {
        console.log(error);
      });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.visible) {
      this.loadSettings(nextProps.trapId);
    } else {
      this.props.setSettingsPaneVisibility(true);
      this.loadSettings(nextProps.trapId);
    }
  }

  closePanel() {
    this.props.setSettingsPaneVisibility(false);
  }

  saveSettings() {
    this.setState({
      loading: true,
    });

    let data = this.state.settings;
    data["id"] = this.props.trapId;

    if (this.props.admin) {
      axios
        .put(this.props.restIp + "/traps", data)
        .then(
          function (response) {
            this.setState({
              loading: false,
            });
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error);
        });
    } else {
      alert("brak uprawnień");
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    let classes = {
      hidden: !this.props.visible,
      //'animated zoomInLeft': this.props.visible
    };

    let modal_classes = cx(classes);
    let width = this.props.visible ? "2" : "0";

    const settings = (
      <div>
        <div>
          <label htmlFor="speed_limit">Predkość dopuszczalna</label>
          <input
            type="number"
            id="speed_limit"
            defaultValue={this.state.settings.speed_limit}
            onChange={(e) =>
              this.setState({
                settings: update(this.state.settings, {
                  speed_limit: { $set: e.target.value },
                }),
              })
            }
          />

          <label htmlFor="speed_display_limit">Anty rekord</label>
          <input
            type="number"
            id="speed_display_limit"
            defaultValue={this.state.settings.speed_display_limit}
            onChange={(e) =>
              this.setState({
                settings: update(this.state.settings, {
                  speed_display_limit: { $set: e.target.value },
                }),
              })
            }
          />

          <label htmlFor="lower_measurement_threshold">
            Czułość - zakres dolny
          </label>
          <select
            id="lower_measurement_threshold"
            defaultValue={this.state.settings.lower_measurement_threshold}
            onChange={(e) =>
              this.setState({
                settings: update(this.state.settings, {
                  lower_measurement_threshold: { $set: e.target.value },
                }),
              })
            }
          >
            <option value="0">2km/h</option>
            <option value="1">10km/h</option>
            <option value="2">25km/h</option>
            <option value="3">60km/h</option>
            <option value="4">110km/h</option>
          </select>

          <label htmlFor="upper_measurement_threshold">
            Czułość - zakres górny
          </label>
          <select
            id="upper_measurement_threshold"
            defaultValue={this.state.settings.upper_measurement_threshold}
            onChange={(e) =>
              this.setState({
                settings: update(this.state.settings, {
                  upper_measurement_threshold: { $set: e.target.value },
                }),
              })
            }
          >
            <option value="0">10km/h</option>
            <option value="1">25km/h</option>
            <option value="2">60km/h</option>
            <option value="3">110km/h</option>
            <option value="4">200km/h</option>
          </select>

          <label htmlFor="range">Zasięg pomiarowy</label>
          <select
            id="range"
            defaultValue={this.state.settings.range}
            onChange={(e) =>
              this.setState({
                settings: update(this.state.settings, {
                  range: { $set: e.target.value },
                }),
              })
            }
          >
            <option value="5">Mały</option>
            <option value="10">Średni</option>
            <option value="15">Wysoki</option>
          </select>

          <label htmlFor="direction">Kierunek pomiaru</label>
          <select
            id="direction"
            defaultValue={this.state.settings.direction}
            onChange={(e) =>
              this.setState({
                settings: update(this.state.settings, {
                  direction: { $set: e.target.value },
                }),
              })
            }
          >
            <option value="1">Zbliżajce</option>
            <option value="2">Oddalajce</option>
            <option value="3">Oba Kierunki</option>
          </select>

          <label htmlFor="display">Flash</label>
          <div style={{ width: "100%", padding: "20px" }}>
            <Button
              outline
              color={this.state.settings.flash ? "success" : "danger"}
              block
              onClick={() =>
                this.setState({
                  settings: update(this.state.settings, {
                    flash: { $set: !this.state.settings.flash },
                  }),
                })
              }
            >
              {this.state.settings.flash ? "On" : "Off"}
            </Button>
          </div>

          <label htmlFor="display">Wywietlacz on/off</label>
          <div style={{ width: "100%", padding: "20px" }}>
            <Button
              outline
              color={this.state.settings.display ? "success" : "danger"}
              block
              onClick={() =>
                this.setState({
                  settings: update(this.state.settings, {
                    display: { $set: !this.state.settings.display },
                  }),
                })
              }
            >
              {this.state.settings.display ? "On" : "Off"}
            </Button>
          </div>

          <label htmlFor="power_save">Oszczędzanie energii</label>
          <div style={{ width: "100%", padding: "20px" }}>
            <Button
              outline
              color={this.state.settings.power_save ? "success" : "danger"}
              block
              onClick={() =>
                this.setState({
                  settings: update(this.state.settings, {
                    power_save: { $set: !this.state.settings.power_save },
                  }),
                })
              }
            >
              {this.state.settings.power_save ? "On" : "Off"}
            </Button>
          </div>
        </div>

        <label htmlFor="text">Tekst</label>
        <input
          type="text"
          id="text"
          defaultValue={this.state.settings.text}
          onChange={(e) =>
            this.setState({
              settings: update(this.state.settings, {
                text: { $set: e.target.value },
              }),
            })
          }
        />

        <div style={{ width: "100%", padding: "20px" }}>
          <Button
            outline
            color="primary"
            block
            onClick={() => this.saveSettings()}
          >
            Zapisz
          </Button>
          {""}
        </div>
      </div>
    );

    return (
      <Col
        className={modal_classes}
        id="trap_settings"
        md={width}
        style={{
          background: "rgb(30, 29, 30)",
          zIndex: 2,
          overflowX: "scroll",
        }}
      >
        <span className="clearfix">
          <h2 className="float-left" style={{ paddingTop: "5px" }}>
            Ustawienia
          </h2>
          <button
            type="button"
            className="close float-right"
            onClick={this.closePanel}
            aria-label="Close"
            style={{ color: "#FFF", padding: "10px 10px 0 0" }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </span>
        <hr />
        {!this.state.loading ? (
          settings
        ) : (
          <p>
            <i
              className="fa fa-cog fa-spin fa-5x fa-fw"
              style={{ margin: "50px", color: "#fff" }}
            ></i>
            <span className="sr-only">Loadings...</span>
          </p>
        )}
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrapSettings.js